import React, { useRef, useState, useEffect } from 'react';
import styles from '../styles/VideoPlayer.module.scss';

export default function VideoPlayer({ src, title }) {
  const videoRef = useRef(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    // reset error when src changes
    setError(false);
    if (videoRef.current) {
      try {
        // reload video source
        videoRef.current.load();
      } catch {
        // ignore
      }
    }
  }, [src]);

  return (
    <div className={styles.playerWrap}>
      {!src ? (
        <div className={styles.placeholder} />
      ) : error ? (
        <div className={styles.error}>Could not find the video</div>
      ) : (
        <video
          ref={videoRef}
          className={styles.player}
          controls
          playsInline
          onError={() => setError(true)}
        >
          <source src={src} />
          {/* Fallback text if browser can't play video at all */}
          Your browser does not support the video tag.
        </video>
      )}
      {title && <div className={styles.caption}>{title}</div>}
    </div>
  );
}
